<template>
  <div class="wrapper">
    <c-el-page-header :downFlag=true  :detail="`图文报告(${currentPage}/${pdfData.length || '1'})`" />
      <svg-icon  icon-class="pre_page" class-name="pre_icon" v-if="currentPage > 1" @click="goPage('pre')"/>
        <div class="pfd-wrapper">
          <div :class="['image-content']" v-for="(item ,index) in pdfData" :key="item">
            <PreviewpdfH5 :ref="'PreviewpdfH5'+index" :index ='index'></PreviewpdfH5>
          </div>
        </div>
      <svg-icon  icon-class="next_page" class-name="next_icon" v-if="currentPage!= pdfData.length" @click="goPage('next')"/>
    <svg-icon
      icon-class="zoom-in"
      class-name="icon-zoom-in"
      @click="zoom()"
      v-if="zoomInOrOut"
    />
    <svg-icon
      icon-class="zoom-out"
      class-name="icon-zoom-in"
      @click="zoom()"
      v-if="!zoomInOrOut"
    />
  </div>
</template>

<script>
import PreviewpdfH5 from '../components/PreviewpdfH5'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreviewpdfH5
  },
  props: {},
  data () {
    return {
      zoomInOrOut: true, // 是否可以放大
      currentPage:1,
      currentIndex:0,
      pdfList:[],
      hospCode: this.$route.query.hospcode,
      tcStType: 1
    }
  },
  watch: {
    pdfData: function (val) {
      this.$nextTick(() => {
        val.forEach((element, index) => {
        // const url = 'http://192.168.1.18:8041/powerfilmer/v1.0/download?filePath=cGRmeGh0dHA6Ly8xOTIuMTY4LjEuMTg6ODg4OC9ncm91cDEvTTAwLzAzL0U2L3dLZ0JFbUpwOEwtQVdxQ2ZBQUVsMnNwaTZZSTEyMi5wZGYseSxodHRwOi8vMTkyLjE2OC4xLjE4Ojg4ODgvZ3JvdXAxL00wMC8wMy9FNS93S2dCRW1KcDdrR0FKX2RuQUFFZG91N2NaM00yMTUucGRm'// 本地测试用
          // const url = 'http://192.168.6.13:8080' + element.getFilePath[0]
          const url = element.getFilePath[0]+`&hospCode=${this.hospCode}&tcStType=1`
          this.$refs[`PreviewpdfH5${index}`][0].openPdf(url)
        })
      })
    }
  },
  computed: {
    ...mapGetters(['homeInfo', 'pdfData'])
  },
  methods: {
    // 布局缩放 放大150% 缩小恢复100%
    zoom () {
      // pdfViewer
      const pdfDom = document.getElementsByClassName('pdfViewer')[0]
      if (pdfDom && this.zoomInOrOut) {
        pdfDom.style =
          'transform-origin:0% 0%; position: relative;transform: scale(1.5, 1.5) translate(0px, 0px);'
      } else {
        pdfDom.style =
          'transform-origin:0% 0%; position: relative;transform: scale(1, 1) translate(0px, 0px);'
      }
      this.zoomInOrOut = !this.zoomInOrOut
    },
    // getScroll (event) {
    //   // 滚动条距离右边的距离scrollRight
    //   const scrollRight = event.target.scrollLeft
    //   // console.log('233', scrollRight, document.body.offsetWidth)
    //   // console.log(2333, document.getElementsByClassName('pfd-wrapper'))
    //   // const dom = document.getElementsByClassName('pfd-wrapper')

    //   if ((scrollRight + 24) < document.body.offsetWidth) {
    //     this.currentPage = 1
    //     // dom.scrollLeft = 0
    //   } else {
    //     const i = Math.ceil((scrollRight + 24) / document.body.offsetWidth)
    //     this.currentPage = i
    //     // dom.scrollLeft = i * document.body.offsetWidth
    //   }
    // },
    goPage (flag) {
      if (flag === 'pre') {
        this.currentPage = this.currentPage - 1
        this.currentIndex = this.currentPage - 1
      } else if (flag === 'next') {
        this.currentPage = this.currentPage + 1
        this.currentIndex = this.currentPage - 1
      }
      this.showPdf(this.currentIndex)
    },
    showPdf (i) {
      // const url = 'http://192.168.6.13:8080' + this.pdfData[i].getFilePath[0]
      const url = this.pdfData[i].getFilePath[0]+`&hospCode=${this.hospCode}&tcStType=1`
      this.$refs[`PreviewpdfH5${i}`][0].openPdf(url)
    }

  },
  created () {
    var params = {
      patientid: this.$route.query.patientid,
      hospcode: this.$route.query.hospcode,
      studyid: this.$route.query.studyid,
      hospdomain: this.$route.query.hospdomain,
      tcStType: this.$route.query.tcStType,
      checkTime:this.$route.query.checkTime
    }
    this.$store
      .dispatch('getImageAndText', params)
      .then(() => {})
      .catch(() => {})
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
@import "../style/theme.scss";
@import "../style/imageAndText.scss";
</style>
